import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Enums from 'utils/EnumsManager';
import styles from '../index.less';

const { DateTimeConfigs, ConditionsInArray } = Enums;
const { TimeRangePrefix } = DateTimeConfigs;

const cx = classNames.bind(styles);

const defaultProps = {
  logic: '',
  filters: []
};
const propTypes = {
  logic: PropTypes.string,
  filters: PropTypes.array,
  fieldsMetaData: PropTypes.array.isRequired
};

// utils
// Conditions mapping
const condArray = ConditionsInArray.map(c => ({
  key: c,
  value: c.replace(/_/g, ' ')
}));
const getConditionDisplayStr = key => {
  const condition = condArray.find(c => c.key === key);
  return condition ? condition.value : '-';
};

// Value mapping
const parseTimeStr = val => {
  // remove prefix
  val = val.replace(TimeRangePrefix, '');
  // replace '_' with ' '
  val = val.replace(/_/, ' ');
  // to lowercase
  return val.toLowerCase();
};
const getValueDisplayStr = val => {
  if (_.startsWith(val, TimeRangePrefix)) {
    return parseTimeStr(val);
  }
  return val;
};

const FilterInfo = ({ logic, filters, fieldsMetaData, createdOn }) => (
  <div className={cx('baseInfo')}>
    <p>
      <FormattedMessage id="page.RealTimeReport.filterBy" />: {logic || 'none'}
    </p>
    <ul style={{ display: 'inline-block' }}>
      {filters.map(f => {
        const { display_num, condition, field_name, value } = f;
        const field = fieldsMetaData.find(f => f.name === field_name);
        const name = field ? field.label : '';
        return (
          <li key={display_num}>
            {display_num}. {name} {getConditionDisplayStr(condition)}{' '}
            {getValueDisplayStr(value)}
          </li>
        );
      })}
    </ul>
    <span className="pull-right">
      <FormattedMessage id="page.RealTimeReport.createdOn" />: {createdOn}
    </span>
  </div>
);

FilterInfo.defaultProps = defaultProps;
FilterInfo.propTypes = propTypes;
export default FilterInfo;



// WEBPACK FOOTER //
// ./src/views/RealTimeReport/components/FilterInfo.jsx